import React from 'react';
import SvgIcon, { IconProps } from './SvgIcon';

export default function OfficeIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M14 22V8c0-2.828 0-4.243-.879-5.121C12.243 2 10.828 2 8 2c-2.828 0-4.243 0-5.121.879C2 3.757 2 5.172 2 8v8c0 2.828 0 4.243.879 5.121C3.757 22 5.172 22 8 22h6ZM6.5 11h-1m5 0h-1m-3-4h-1m1 8h-1m5-8h-1m1 8h-1M18.5 15h-1m1-4h-1M18 8h-4v14h4c1.886 0 2.828 0 3.414-.586C22 20.828 22 19.886 22 18v-6c0-1.886 0-2.828-.586-3.414C20.828 8 19.886 8 18 8Z"
      />
    </SvgIcon>
  );
}
